<template>
    <div class="page">
        <div class="page-text-wrap">
            <h1>Heste og Smådyr</h1>
            <img class="img-responsive" src="@/assets/info/heste1.jpg" />
            <p>Heste og smådyr har altid været en del af Vorbasse Marked lige siden studene blev drevet afsted på Hærvejen. I dag er der dog ikke adgang for klovbærende dyr, men en masse heste og smådyr skifter ejer på Vorbasse Marked.</p>
            <p>I gammel tid var antallet af heste meget større, men med indførslen af traktoren, faldt antallet af heste i landbruget og dermed også antallet af heste, der kunne handles på markedet.</p>
        </div>
    </div>
</template>

<script>
	export default {
		name: "Hestemarked.vue"
	}
</script>
